export default [
  {
    title: 'Component(Sidebar):homepage',
    icon: 'HomeIcon',
    route: 'homepage',
    action: 'visit',
    resource: 'homepage',
  },
]
